'use client';
import Star from '@/app/_components/ui/icons/Star.svg';
import React from 'react';
import { useState, useEffect } from 'react';
import ScrollToSection from '../share/ScrollToSection';

export default function SpReviewsSummary({
  sku,
  indices,
  cmCounts,
  questionCounts,
  productCode,
}) {
  const [copySuccess, setCopySuccess] = useState(false);

  useEffect(() => {
    const timeId = setTimeout(() => {
      setCopySuccess(false);
    }, 3000);
    return () => {
      clearTimeout(timeId);
    };
  }, [copySuccess]);
  return (
    <>
      <div className="extraProductInfo mt-2.5 text-xs pb-2 ">
        <div className="flex items-center max-w-full overflow-auto ">
          {productCode && (
            <div className="flex items-center ml-2">
              <div className="text-xs text-gray-400 whitespace-nowrap ">
                کد کالا :
              </div>
              <div className="flex items-center  px-2 relative  ">
                <span className="text-dark-gray  ">
                  {productCode && productCode.length > 12
                    ? productCode.slice(0, 12) + '...'
                    : productCode}
                </span>
              </div>
              <div className="h-[15px]  border-l border-light-gray-300"></div>
            </div>
          )}

          {sku && (
            <div className="flex items-center">
              <div className="text-xs text-gray-400 whitespace-nowrap ">
                SKU:
              </div>
              <div className="flex items-center  px-2 relative  ">
                <span className="text-dark-gray  ">
                  {sku && sku.length > 12 ? sku.slice(0, 12) + '...' : sku}
                </span>
              </div>
              <div className="h-[15px]  border-l border-light-gray-300"></div>
            </div>
          )}

          <div className="flex py-4 md:py-0">
            <div className="flex items-center pl-2.5 px-2 ">
              <Star fill="#FFC308" />
              <div>
                <span className="text-light-gray-900 px-1">
                  {indices?.score}
                </span>
                <span className="text-gray-200">({indices?.total})</span>
              </div>
            </div>
            <div className="h-[15px]  border-l border-light-gray-300"></div>

            <ScrollToSection sectionId="spComments">
              <div className="flex items-center  px-2  text-ocean-blue">
                <span className="pl-1"> {cmCounts} </span>
                <span>دیدگاه</span>
              </div>
            </ScrollToSection>

            <div className="h-[15px]  border-l border-light-gray-300"></div>

            <ScrollToSection sectionId="spAskAnswer">
              <div className="flex items-center px-2  text-ocean-blue">
                <span className="pl-1"> {questionCounts} </span>
                <span>پرسش</span>
              </div>
            </ScrollToSection>
          </div>
        </div>
      </div>
    </>
  );
}
